<style>
    .img-container img{
        width:150px;
    }
</style>

<template>
    <Modal
            v-model="showModal"
            :title="title"
            :loading="true"
            :styles="{top: '20px',width:'900px'}"
    >
        <div slot="footer">
            <Button type="text" size="large" @click="modalCancel">取消</Button>
            <Button type="primary" size="large" @click="handleSubmit('form')" :loading="saving">确定</Button>
        </div>
        <Form :model="formItem" :rules="ruleValidate" :label-width="80" ref="form">
            <FormItem label="标题" prop="title" >
                <Input v-model="formItem.title" placeholder="" style="width:260px" />
            </FormItem>
            <FormItem label="状态" prop="state">
                <Select v-model="formItem.state" style="width:260px">
                    <Option :value="1" label="正常" ></Option>
                    <Option :value="0" label="禁用"></Option>
                </Select>
            </FormItem>
            <FormItem label="校区" prop="zone_id" >
                <Select v-model="formItem.zone_id" style="width:260px">
                    <Option v-for="zone in zoneList" :value="zone.id" :key="zone.id">{{ zone.name }}</Option>
                </Select>
            </FormItem>
            <FormItem label="图片">
                <div class="img-container">
                    <img v-if="!formItem.img" src="@/assets/images/default_img.png">
                    <img v-else :src="formItem.img">
                </div>
                <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :format="['jpg','jpeg','png']"
                        :max-size="500"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        :on-success="handleSuccess"
                        :before-upload="getKey"
                        name="file"
                        action="https://upload.qiniup.com/"
                        :data="{token:token,key:file}"
                        style="display: inline-block;width:50px;">
                    <Button type="dashed">上传文件</Button>
                </Upload>
            </FormItem>
            <FormItem label="文本1" prop="txt1" >
                <Input v-model="formItem.txt1" placeholder="预约热线：######" style="width:260px" />
            </FormItem>
            <FormItem label="文本2" prop="txt2" >
                <Input v-model="formItem.txt2" placeholder="预约体验" style="width:260px" />
            </FormItem>
            <FormItem label="文本3" prop="txt3" >
                <Input v-model="formItem.txt3" placeholder="预约成功！我们将尽快联系您" style="width:260px" />
            </FormItem>
        </Form>
    </Modal>
</template>

<script>
    export default {
        name: 'sign-form',
        data(){
            return {
                title:'',
                showModal:false,
                pageName: this.$route.name,
                saving:false,
                file: null,
                token: null,
                zoneList:[],
                formItem: {
                    id:null,
                    title: null,
                    img:null,
                    state: 1,
                    zone_id:null,
                    txt1:null,
                    txt2:null,
                    txt3:null
                },
                ruleValidate: {
                    title: [
                        { required: true, message: '请输入标题', trigger: 'blur' }
                    ],
                    state:[
                        { type:'integer', trigger: 'blur' }
                    ],
                    zone_id:[
                        { required: true,type:'integer', trigger: 'blur',message: '请选择校区' }
                    ]
                }
            }
        },
        mounted() {
            this.$api.comm.getQiNiuToken().then(res => {
                if (res.state == "ok") {
                    this.token=res.data;
                } else {
                    this.$Message.error(res.msg)
                }
            })

            this.$api.zone.getAll().then(resp => {
                if (resp.state == 'ok'){
                    this.zoneList = resp.data;
                }else{
                    this.$Message.error('获取校区列表异常：'+resp.msg);
                }
            });
        },
        methods:{

            packagingFormData(){
                let postFormData = {};
                for (var i in this.formItem) {
                    if (this.formItem.hasOwnProperty(i)) {
                        postFormData['eduSignup.'+i] = this.formItem[i];
                    }
                }
                return postFormData;
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            },
            modalCancel (){
                this.showModal = false;
                this.$refs['form'].resetFields();
            },
            handleSubmit (name) {
                let self = this;
                self.$refs[name].validate((valid) => {
                    try{
                        if (valid) {
                            try{
                                self.saving = true;
                                self.$api.signup.save(self.packagingFormData()).then(resp => {
                                    if (resp.state == 'ok'){
                                        self.$Message.info({
                                            content:'提交成功',
                                            onClose (){
                                                self.showModal = false;
                                            }
                                        });
                                        self.$emit('close');
                                    }else{
                                        self.saving = false;
                                        self.$Message.error(resp.msg);
                                    }
                                });
                            }catch (err){
                                console.log(err);
                            }

                        } else {
                            this.$Message.error('表单校验不通过');
                        }
                    }catch(err){
                        console.log(err);
                    }

                })
            },
            handleFormatError(file) {
                this.$Notice.warning({
                    title: '文件类型错误',
                    desc: '请上传后缀为.jpg/.jpeg/.png的图片'
                });
            },
            handleMaxSize(file) {
                this.$Notice.warning({
                    title: '图片太大',
                    desc: '图片太大，请上传不超过500KB的图片'
                });
            },
            handleSuccess(file) {
                if (file.key) {
                    this.formItem.img = "http://cdn.xmxiaomai.com/" + file.key;
                } else {
                    this.$Message.error("上传出现错误，请重新选择文件")
                }
            },
            getKey(file) {
                var ext = ((file.name).split("."))[1];
                var name = new Date().getTime();
                this.$refs.upload.data.key = name + "." + ext;
                return true;
            },
            loadInfo(id,callback){
                this.$api.signup.getOne({id:id}).then(resp => {
                    if (resp.state == 'ok'){
                        this.formItem.id = resp.data.id;
                        this.formItem.title = resp.data.title;
                        this.formItem.state = resp.data.state;
                        this.formItem.zone_id = resp.data.zone_id;
                        this.formItem.img = resp.data.img;
                        this.formItem.txt1 = resp.data.txt1;
                        this.formItem.txt2 = resp.data.txt2;
                        this.formItem.txt3 = resp.data.txt3;

                        callback && callback();
                    }
                });
            },
            showWin(signupId){
                let self = this;
                self.saving = false;

                this.formItem.id = null;
                this.formItem.title = null;
                this.formItem.state = null;
                this.formItem.zone_id = null;
                this.formItem.img = null;
                this.formItem.txt1 = null;
                this.formItem.txt2 = null;
                this.formItem.txt3 = null;

                self.$refs['form'].resetFields();
                if (signupId){
                    self.title = '修改';
                    self.loadInfo(signupId,function(){
                        self.showModal = true;
                    });
                }else{
                    self.title = '新增';
                    self.showModal = true;
                }
            }
        }
    }
</script>
